import {
  GET_VENDOR_SUPPORT_TICKETS_REQUEST,
  GET_VENDOR_SUPPORT_TICKETS_SUCCESS,
  GET_VENDOR_TICKET_STATUS_REQUEST,
  GET_VENDOR_TICKET_STATUS_SUCCESS,
  GET_VENDOR_TICKET_STORES_REQUEST,
  GET_VENDOR_TICKET_STORES_SUCCESS,
  GET_VENDOR_TICKET_CONVERSATION_REQUEST,
  GET_VENDOR_TICKET_COMMENTS_REQUEST,
  GET_VENDOR_TICKET_COMMENTS_SUCCESS,
  GET_VENDOR_TICKET_CONVERSATION_SUCCESS,
  SHARE_VENDOR_TICKET_REQUEST,
  SHARE_VENDOR_TICKET_SUCCESS,
  SHARE_VENDOR_TICKET_FAILURE,
  UPDATE_VENDOR_TICKET_REQUEST,
  UPDATE_VENDOR_TICKET_SUCCESS,
  UPDATE_VENDOR_TICKET_FAILURE,
} from "./type";


export const getVendorSupportTicketsRequest = (data) => {
  return { type: GET_VENDOR_SUPPORT_TICKETS_REQUEST, payload: data };
};

export const getVendorSupportTicketsSuccess = (data) => {
  return { type: GET_VENDOR_SUPPORT_TICKETS_SUCCESS, payload: data };
};

export const getVendorTicketStatusRequest = () => {
  return { type: GET_VENDOR_TICKET_STATUS_REQUEST };
};

export const getVendorTicketStatusSuccess = (data) => {
  return { type: GET_VENDOR_TICKET_STATUS_SUCCESS, payload: data };
};


export const getVendorTicketStoresRequest = () => {
  return { type: GET_VENDOR_TICKET_STORES_REQUEST };
};

export const getVendorTicketStoresSuccess = (data) => {
  return { type: GET_VENDOR_TICKET_STORES_SUCCESS, payload: data };
};


export const getVendorTicketConversationRequest = (data) => {
  return { type: GET_VENDOR_TICKET_CONVERSATION_REQUEST, payload: data };
};

export const getVendorTicketConversationSuccess = (data) => {
  return { type: GET_VENDOR_TICKET_CONVERSATION_SUCCESS, payload: data };
};


export const getVendorTicketCommentsRequest = (data) => {
  return { type: GET_VENDOR_TICKET_COMMENTS_REQUEST, payload: data };
};

export const getVendorTicketCommentsSuccess = (data) => {
  return { type: GET_VENDOR_TICKET_COMMENTS_SUCCESS, payload: data };
};

export const shareVendorTicketRequest = (data) => {
  return { type: SHARE_VENDOR_TICKET_REQUEST, payload: data };
};

export const shareVendorTicketSuccess = (data) => {
  return { type: SHARE_VENDOR_TICKET_SUCCESS, payload: data };
};

export const shareVendorTicketFailure = (data) => {
  return { type: SHARE_VENDOR_TICKET_FAILURE, payload: data };
};


export const updateVendorTicketRequest = (data) => {
  return { type: UPDATE_VENDOR_TICKET_REQUEST, payload: data };
};

export const updateVendorTicketSuccess = (data) => {
  return { type: UPDATE_VENDOR_TICKET_SUCCESS, payload: data };
};

export const updateVendorTicketFailure = (data) => {
  return { type: UPDATE_VENDOR_TICKET_FAILURE, payload: data };
};
